$(document).ready(function() {

    var questions = [
        {
            Id: 1,
            Question: 'Are you Male Or Female?',
            Type: 'MaleOrFemale',
            Category: 'null',
            Answer: [{label: 'A', desc: 'Male', RecommendationId: 0, nextQuestionId: 3}, {label: 'B', desc: 'Female', RecommendationId: 0, nextQuestionId: 2}]
        },
        {
            Id: 2,
            Question: 'You are ____',
            Type: 'DetailQuestion',
            Category: 'null',
            Answer: [{label: 'A', desc: 'Pregnant', RecommendationId: 103, nextQuestionId: -1}, {label: 'B', desc: 'Thinking about pregnancy', RecommendationId: 104, nextQuestionId: -1}, {label: 'C', desc: 'None of both', RecommendationId: null, nextQuestionId: 3}]
        },
        {
            Id: 3,
            Question: 'Are you immunocompromised or have a weakened immune system?',
            Type: 'DetailQuestion',
            Category: 'Health',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 101, nextQuestionId: 4}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 4}]
        },
        {
            Id: 4,
            Question: 'Have you ever suffered from stroke, heart disease, hypertension or any chronic diseases?',
            Type: 'DetailQuestion',
            Category: 'Health',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 102, nextQuestionId: 5}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 5}]
        },
        {
            Id: 5,
            Question: 'How old are you?',
            Type: 'DetailQuestion',
            Category: 'Age',
            Answer: [{label: 'A', desc: 'Below 18 years old', RecommendationId: 201, nextQuestionId: 6}, {label: 'B', desc: '18 – 64 years old', RecommendationId: 202, nextQuestionId: 6}, {label: 'C', desc: 'Above 65 years old', RecommendationId: 203, nextQuestionId: 6}]
        },
        {
            Id: 6,
            Question: 'Do you travel overseas often (2 – 3 times a year)?',
            Type: 'DetailQuestion',
            Category: 'LifeStyle',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 301, nextQuestionId: 7}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 7}]
        },
        {
            Id: 7,
            Question: 'Do you: <br><ul class=ul-in-question-title> <li>Require medicinal drug injections</li> <li>or Partake in high risk sexual activities and/or have multiple sex partners</li> <li>or Have/Are you planning to get a tattoo or body piercing?</li> </ul>',
            Type: 'DetailQuestion',
            Category: 'LifeStyle',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 302, nextQuestionId: 8}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 8}]
        },
        {
            Id: 8,
            Question: 'Are you a healthcare worker or working in a hospital?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 401, nextQuestionId: 9}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 9}]
        },
        {
            Id: 9,
            Question: 'Are you a construction worker?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 402, nextQuestionId: 10}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 10}]
        },
        {
            Id: 10,
            Question: 'Does your job require food handling?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 403, nextQuestionId: 11}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 11}]
        },
        {
            Id: 11,
            Question: 'Do you work in a closed community (e.g. schools, offices, immigration)?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 404, nextQuestionId: 12}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 12}]
        },
        {
            Id: 12,
            Question: 'Are you a parent/caregiver of children?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 405, nextQuestionId: 13}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: 13}]
        },
        {
            Id: 13,
            Question: 'Are you a caregiver of an older person above the age of 50?',
            Type: 'DetailQuestion',
            Category: 'Occupation',
            Answer: [{label: 'A', desc: 'Yes', RecommendationId: 406, nextQuestionId: -1}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: -1}]
        },
        // {
        //     Id: 14,
        //     Question: 'Are you enlisted or working in the army?',
        //     Type: 'DetailQuestion',
        //     Category: 'Occupation',
        //     Answer: [{label: 'A', desc: 'Yes', RecommendationId: 407, nextQuestionId: -1}, {label: 'B', desc: 'No', RecommendationId: 0, nextQuestionId: -1}]
        // },

    ];

    var recommendations = [
        {
            Id: 101,
            Message: 'Immunocompromised or have a weakened immune system<sup>1,2</sup>',
            Vaccines: ['Influenza', 'Pneumococcal', 'Meningococcal', 'Hepatitis B', 'Tdap (Diphtheria-Tetanus-Pertussis)','HPV (males)'],
            Info: null
        },
        {
            Id: 102,
            Message: 'Suffered from stroke, heart disease, hypertension or any chronic diseases<sup>2</sup>',
            Vaccines: ['Influenza','Pneumococcal', 'Hepatitis B'],
            Info: null
        },
        {
            Id: 103,
            Message: 'Pregnant<sup>1,2</sup>',
            Vaccines: ['Tdap (Diphtheria-Tetanus-Pertussis)', 'Influenza'],
            Info: null
        },
        {
            Id: 104,
            Message: 'Thinking about pregnancy<sup>3</sup> ',
            Vaccines: ['MMR (for Rubella)<br>Note: If you are planning to get pregnant, talk to your doctor about which immunisations you can consider getting before pregnancy.'],
            Info: null
        },
        {
            Id: 201,
            Message: 'Below 18 years old',
            Vaccines: [],
            Info: {PreText: 'Click ', LinkText: 'here', LastText: ' to find out more about Child Immunisation Schedule', Link: 'vaccination-schedules-resources.html#child'}
        },
        {
            Id: 202,
            Message: '18 – 64 years old',
            Vaccines: [],
            Info: {PreText: 'Click ', LinkText: 'here', LastText: ' to  find out more about Adult Immunisation Schedule', Link: 'vaccination-schedules-resources.html#adult'}
        },
        {
            Id: 203,
            Message: 'Above 65 years old<sup>2</sup>',
            Vaccines: ['Influenza','Tdap (Diphtheria-Tetanus-Pertussis)','Zoster','Pneumococcal'],
            Info: null
        },
        {
            Id: 301,
            Message: 'Travel overseas often (2 – 3 times a year)',
            Vaccines: ['Vaccination requirements differ from country to country. Check with your doctor before travelling abroad.<sup>4</sup>','If you are travelling to Hajj & Umrah, please consider vaccinating against the following diseases<sup>5</sup>: <ul><li>Meningococcal disease</li><li>Influenza / Flu disease</li><li>Pneumococcal disease</li></ul>'],
            Info: null,
        },
        {
            Id: 302,
            Message: '<ul> <li>Require medicinal drug injections</li> <li>or Partake in high risk sexual activities and/or have multiple sex partners</li> <li>or Have or are you planning to get a tattoo or body piercing?<sup>1,2</sup></li> </ul>',
            Vaccines: ['Hepatitis A','Hepatitis B','HPV'],
            Info: null
        },
        {
            Id: 401,
            Message: 'Healthcare worker or working in a hospital<sup>2</sup>',
            Vaccines: ['Hepatitis B','Measles, mumps and rubella (MMR)','Influenza','Tdap (Pertussis)','Varicella'],
            Info: null
        },
        {
            Id: 402,
            Message: 'Construction worker<sup>6</sup>',
            Vaccines: ['Tdap (Tetanus, Diphtheria, Pertussis)','Influenza','Hepatitis B'],
            Info: null
        },
        {
            Id: 403,
            Message: 'Your job requires food handling<sup>2</sup>',
            Vaccines: ['Hepatitis A','Typhoid'],
            Info: null
        },
        {
            Id: 404,
            Message: 'Work in a closed community (e.g. schools, offices, immigration)<sup>2</sup>',
            Vaccines: ['Hepatitis B','Influenza','Tdap (Diphtheria-Tetanus-Pertussis)','Measles, mumps and rubella (MMR)','Varicella'],
            Info: null
        },
        {
            Id: 405,
            Message: 'Parent/caregiver of children<sup>2</sup>',
            Vaccines: ['Hepatitis A','Hepatitis B','Influenza','Tdap (Diphtheria-Tetanus-Pertussis)','Measles, mumps and rubella (MMR)','Varicella'],
            Info: null
        },
        {
            Id: 406,
            Message: 'Caregiver of an older person above the age of 50<sup>7</sup>',
            Vaccines: ['Influenza'],
            Info: null
        },
        // {
        //     Id: 407,
        //     Message: 'Enlisted or working in the army',
        //     Vaccines: ['Meningococcal','Hepatitis B','Influenza ','Polio','Tetanus','Varicella'],
        //     Info: {PreText: '<br>Click ', LinkText: 'here', LastText: ' to find out more', Link: 'https://www.mindef.gov.sg/oms/dam/publications/eBooks/More_eBooks/recruits_handbook_dec2016.pdf'}
        // },

    ];

    var firstQuestion = questions[0];
    var femaleQuestion = questions[1];
    var firstHealthQuestion = questions[2];
    var results = InitResult();
    var gender = '';
    ShowWelcome(firstQuestion);

    function InitResult() {
        var results = [];
        questions.forEach(function(item) {
            results.push({QuestionId: item.Id, QuestionCategory: item.Category, IsAnswerd: false, RecommendationId: 0});
        });
        return results;
    }

    function ShowWelcome(question) {
        // $('.detailPage .header').html('<div class="col-6"> <img class="all_genders" src="assets/images/halo_all_genders.png" alt="male"></div><div class="col-6 margin-auto"><h3 class="header-title">WELCOME TO HALO</h3></div>');
        $('.detailPage .main-content').html(RenderWelcome(question));
    }

    function ShowQuestion(question) {
        var headerImage = (gender === 'MALE') ? 'halo_male.png' : 'halo_female.png';
        var headerTitle = gender;
        var subTitle = question.Category !== 'null' ? question.Category : '';
        $('.detailPage .header').html('<div class="col-6"> <img class="male" src="assets/images/' + headerImage + '" alt="male"></div><div class="col-6 margin-auto"><h3 class="header-title short-text">' + headerTitle + '</h3><h4 class="header-sub-title">' + subTitle + '</h4></div>');
        $('.detailPage .main-content').html(RenderQuestion(question));
    }

    function ShowFinalResult () {
        var headerImage = (gender === 'MALE') ? 'halo_male.png' : 'halo_female.png';
        var headerTitle = gender;
        $('.detailPage .header').html('<div class="col-6"> <img class="male" src="assets/images/' + headerImage + '" alt="male"></div><div class="col-6 margin-auto"><h3 class="header-title short-text">' + headerTitle + '</h3></div>');
        $('.detailPage .main-content').html(RenderFinalResult());
    }

    function RenderWelcome(question) {
        return '<div class="border-layer"><div class="question-title"><h4 class="hdrtxt strongbold text-uppercase text-center"><div class="grp1"><span>Diseases cross borders,</span><span> they know no boundaries,</span></div><div class="grp1"><span> they do not choose any </span><span> age, gender or status</span></div></h4><h5>Simplify what diseases to vaccinate against with the H.A.L.O. checklist<sup>1</sup> by looking at:</h5><div class="container-fluid halotextheading"><div class="row"><div class="col-md-3 col-sm-3 col-12"><h5><span>H</span>ealth</h5></div><div class="col-md-2 col-sm-2 col-12"><h5><span>A</span>ge</h5></div> <div class="col-md-3 col-sm-3 col-12"><h5><span>L</span>ifestyle</h5></div><div class="col-md-4 col-sm-4 col-12"><h5><span>O</span>ccupation</h5></div> </div></div><h5>Talk to your healthcare professional today to find out which vaccines are right for you!</h5><!--<p>Vaccination is one of the best ways children and adults can protect themselves from potentially harmful diseases. Incidences of some diseases may change over time, but they still persist in other countries.</p><p>Vaccine-preventable diseases can be very serious, may require hospitalization, or even be deadly - especially in infants and young children.</p><p>Adults need to keep their vaccinations up to date because immunity from childhood vaccines can wear off over time.</p><p>Learn more about the <u><em>other vaccines that may be recommended for you</em></u> and talk to your healthcare professional about which vaccines are right for you.</p>--></div></div><div class="answer-options row"  question-id="' + question.Id + ' question-category="' + question.Category + '"><div class="col-md-6"> <button type="button" class="btn btn-default btn-custom-default box-shadow answer-option" next-question-id=' + question.Answer[0].nextQuestionId + '>MALE</button></div><div class="col-md-6"> <button type="button" class="btn btn-default btn-custom-default box-shadow answer-option" next-question-id=' + question.Answer[1].nextQuestionId + '>FEMALE</button></div></div>';
    }

    function RenderQuestion(question) {
        var tempHtml = '<div class="border-layer"><div class="question-title"><p class="title-larger">' + question.Question + '</p></div></div><div class="answer-options"  question-id="' + question.Id + '" question-category="' + question.Category + '"><ul class="list-answers">';
        question.Answer.forEach(function(item) {
            tempHtml += '<li class="box-shadow row answer-option" next-question-id=' + item.nextQuestionId + ' recommendation-id=' + item.RecommendationId + '><div class="index col-2 col-sm-1"> <span>' + item.label + '</span></div> <span class="answer col-10 col-sm-11">' + item.desc + '</span></li>';
        });
        tempHtml += '</ul></div><div class="navigation"> <button type="button" class="btn btn-default btn-custom-primary box-shadow btn-back">BACK</button></div>';
        return tempHtml;
    }

    function RenderFinalResult() {
        var tempHtml = '<div class="table-results"><table class="table table-bordered"><thead><tr><th class="border-right table-head">Your Responses</th><th class="table-head">Vaccination Checklist <br> to discuss with your doctor</th></tr></thead><tbody>';
        results.forEach(function(item) {
            if (item.RecommendationId > 0) {
                recommendations.forEach(function(recommendation) {
                    if (recommendation.Id === item.RecommendationId) {
                        tempHtml += '<tr><th>' + recommendation.Message + '</th><td><ul>';
                        recommendation.Vaccines.forEach(function(vaccine) {
                            tempHtml += '<li>' + vaccine + '</li>';
                        });

                        if (recommendation.Info) {
                            tempHtml += '</ul>' + recommendation.Info.PreText + '<a target="_blank" class="find-out-more" href="' + recommendation.Info.Link + '">' + recommendation.Info.LinkText + '</a>' + recommendation.Info.LastText + '</td></tr>';
                        } else {
                            tempHtml += '</ul></td></tr>';
                        }
                    }
                });
            }
        });
        tempHtml += '</tbody></table></div><div class="navigation"> <button type="button" class="btn btn-default btn-custom-primary box-shadow btn-reload">Re-test</button></div>';
        return tempHtml;
    }

    $(document).on('click','.answer-options .answer-option', function () {
        // Add to results
        var questionId = parseInt($(this).parents('.answer-options').attr('question-id'));
        var nextQuestionId = parseInt($(this).attr('next-question-id'));
        var recommendationId = ($(this).attr('recommendation-id')) ? parseInt($(this).attr('recommendation-id')) : 0;

        results.forEach(function(item) {
            if (nextQuestionId === -1) item.IsAnswerd = true;

            if (item.QuestionId === questionId) {
                item.IsAnswerd = true;
                item.RecommendationId = recommendationId;
            }
        });

        // Set gender
        if (questionId === firstQuestion.Id) {
            gender = ($(this).text() === 'MALE') ? 'MALE' : 'FEMALE';
        }

        var nextQuestionId = parseInt($(this).attr('next-question-id'));
        if (nextQuestionId === -1) {
            ShowFinalResult();
        } else {
            var nextQuestion;
            questions.forEach(function(item) {
                if (item.Id === nextQuestionId) nextQuestion = item;
            });
            if (nextQuestion) ShowQuestion(nextQuestion);
        }

    });

    $(document).on('click','.detailPage .btn-back', function () {
        var questionId = parseInt($('.answer-options').attr('question-id'));
        var preQuestion = firstQuestion;

        if (questionId === firstHealthQuestion.Id && gender === 'FEMALE'){
            preQuestion = femaleQuestion;
        } else {
            questions.forEach(function(item) {
                if (item.Answer[0].nextQuestionId === questionId) {
                    preQuestion = item;
                }
            });
        }

        if (preQuestion === firstQuestion) {
            ShowWelcome(firstQuestion);
        } else {
            ShowQuestion(preQuestion);
        }
    });

    $(document).on('click','.detailPage .btn-reload', function () {
        results = InitResult();
        ShowWelcome(firstQuestion);

    });

});
